import React, { useState } from 'react'
import { Box, Button } from '@mui/material'
import { useAtomValue, useSetAtom } from 'infrastructure/state/jotai.wrapper'
import {
  allPrimaryTreesByTreeId,
  allProductsWithPrimaryTreeAtom,
  allProductsWithPrimaryTreeByTreeIdAtom,
  useMastersByIdWithErrorNotification,
} from 'shared/api/masters'
import { doAdminQueries, IQueryInfo } from 'infrastructure/api'
import { Table } from 'shared/ui/Table/Table'
import { useSortableColumns } from '../resourceList/tableUtility'
import { useProductParams } from './utility'
import { IMasterCurricula } from 'infrastructure/api'

export function ProductsVerification() {
  return (
    <Box>
      <Box>Products Verification</Box>
      <MissingMastersTable />
    </Box>
  )
}

interface MissingData extends IMasterCurricula {
  versionCount: number
  pTreeId?: number
}

function MissingMastersTable() {
  const primaryTrees = useAtomValue(allPrimaryTreesByTreeId)
  const products = useAtomValue(allProductsWithPrimaryTreeByTreeIdAtom)
  const masters = useMastersByIdWithErrorNotification() ?? {}
  const missing = Object.keys(masters)
    .filter((id) => !(id in products))
    .map<MissingData>((id) => {
      const [version] = masters[id]
      return {
        ...version,
        versionCount: masters[id].length,
        pTreeId: primaryTrees[id]?.id,
      }
    })

  const columns = [
    {
      title: 'VersionCount',
      width: 50,
      rowContent({ versionCount }: MissingData) {
        return versionCount
      },
      sortable: 'versionCount',
    },
    {
      title: 'Title',
      width: 100,
      rowContent({ title }: MissingData) {
        return title
      },
      sortable: 'title',
    },
    {
      title: 'PrimaryTree',
      width: 100,
      rowContent({ pTreeId }: MissingData) {
        if (pTreeId) {
          return `ID: ${pTreeId}`
        }
        return 'MISSING'
      },
      sortable: 'pTreeId',
    },
    {
      title: 'Created At',
      width: 50,
      rowContent({ createdAt }: MissingData) {
        return createdAt
      },
      sortable: 'createdAt',
    },
    {
      title: 'Create Product',
      width: 100,
      rowContent(data: MissingData) {
        return <CreateButton data={data} />
      },
    },
  ]

  const { sorted, columns: withSort } = useSortableColumns(missing, columns)

  return (
    <Table title="Masters Verification" columns={withSort} items={sorted} />
  )
}

function CreateButton({ data }: { data: MissingData }) {
  const [gettingParams, setGettingParams] = useState(false)
  const getParams = useProductParams()
  const [theParams, setTheParams] = useState<IQueryInfo>()
  const [error, setError] = useState('')
  const doRefresh = useSetAtom(allProductsWithPrimaryTreeAtom)

  const doCreate = async () => {
    if (!theParams) return
    await doAdminQueries([theParams])
    doRefresh()
  }
  const doGetParams = async () => {
    setGettingParams(true)
    const { params, error } = await getParams(data)
    setTheParams(params)
    setError(error ?? '')
  }
  if (error) {
    return <Box>{error}</Box>
  }
  if (theParams) {
    return <Button onClick={doCreate}>Create Product</Button>
  }
  return (
    <Button disabled={gettingParams} onClick={doGetParams}>
      GetParams
    </Button>
  )
}
